import {
  Avatar,
  Box,
  Collapse,
  Grid,
  Hidden,
  IconButton,
  makeStyles,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import clsx from "clsx";
import { useState } from "react";
import ExternalLinkButton from "src/components/Button/ExternalLinkButton";
import ArrowAnimationIcon from "src/components/Icon/ArrowAnimationIcon";
import { formatAddress, numberWithCommas, toFixed } from "src/services/utils";
import CollapseItems from "./CollapseItems";

const useStyle = makeStyles((theme) => ({
  paper: {
    padding: 0,
  },
  item: {
    borderRadius: "10px 10px 0px 0px",
    padding: "0.5rem 1.5rem 0.5rem 1.5rem",
  },
  activeItem: {
    backgroundColor: theme.palette.background.subPaper,
  },
}));

export default function AssetRow({ asset, setSelectedAsset, setIsDetail, ...props }) {
  const cls = useStyle();
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.only("xs"));

  function onRowClick() {
    if (matches) {
      setSelectedAsset(asset);
      setIsDetail(true);
    } else setOpen(!open);
  }

  return (
    <Box {...props} mb={2}>
      <Paper className={cls.paper}>
        <div onClick={() => onRowClick()} style={{ cursor: "pointer" }}>
          <Grid container className={clsx(cls.item, { [cls.activeItem]: open })}>
            <Grid item md={3} sm={3} xs={6}>
              <Box display="flex" justifyContent="flex-start" alignItems="center" height="100%">
                <Avatar src={asset.image} style={{ width: "30px", height: "30px", marginRight: "0.5rem" }} />
                <Typography variant="h5">{asset.symbol}</Typography>
              </Box>
            </Grid>
            <Hidden smDown>
              <Grid item md={2}>
                <Box display="flex" justifyContent="flex-start" alignItems="center" height="100%">
                  <Typography>{formatAddress(asset.address, 3)}</Typography>
                  <ExternalLinkButton hash={asset.address} config={{ pool: "trava-bsc" }} />
                </Box>
              </Grid>
            </Hidden>
            <Grid item md={3} sm={3} xs={6}>
              <Box display="flex" justifyContent="flex-start" alignItems="center" height="100%">
                <Typography variant="subtitle2">{`$${numberWithCommas(toFixed(asset.totalSupply, 2))}`}</Typography>
              </Box>
            </Grid>
            <Hidden xsDown>
              <Grid item md={2} sm={3}>
                <Box display="flex" justifyContent="flex-start" alignItems="center" height="100%">
                  <Typography variant="subtitle2">{`$${numberWithCommas(toFixed(asset.totalBorrow, 2))}`}</Typography>
                </Box>
              </Grid>
              <Grid item md={1} sm={2}>
                <Box display="flex" justifyContent="flex-start" alignItems="center" height="100%">
                  <Typography>{`$${toFixed(asset.price, 2)}`}</Typography>
                </Box>
              </Grid>
            </Hidden>
            <Hidden smDown>
              <Grid item md={1}>
                <Box display="flex" justifyContent="flex-end" alignItems="center" height="100%">
                  <IconButton edge="start" onClick={() => setOpen(!open)}>
                    <ArrowAnimationIcon color="primary" isTransform={open} />
                  </IconButton>
                </Box>
              </Grid>
            </Hidden>
          </Grid>
        </div>
        {!matches && (
          <Collapse in={open}>
            <Box p="1.5rem">
              <CollapseItems asset={asset} />
            </Box>
          </Collapse>
        )}
      </Paper>
    </Box>
  );
}
